import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = {
  key: 0,
  d: "M3.33333 8H12.6667M12.6667 8L8 3.33333M12.6667 8L8 12.6667",
  stroke: "currentColor",
  "stroke-width": "1.33",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_3 = {
  key: 1,
  d: "M1.33398 14.6667L2.94798 11.16C2.33398 10.0733 2.00065 8.84 2.00065 7.55333C2.00065 3.93333 4.98732 1 8.66732 1C12.3473 1 15.334 3.93333 15.334 7.55333C15.334 11.1733 12.3473 14.1067 8.66732 14.1067C7.54065 14.1067 6.46732 13.8267 5.52065 13.3333L1.33398 14.6667Z",
  stroke: "currentColor",
  "stroke-width": "1.33",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_4 = {
  key: 2,
  d: "M12.72 13.04C12.24 13.5733 11.6267 13.7867 11.0267 13.6267C9.28 13.16 6.8 11.8 5.06667 9.85333C3.33333 7.90667 2.12 5.12 1.70667 3.16C1.56 2.48667 1.74667 1.8 2.22667 1.26667L2.24 1.25333C2.52 0.94 2.94667 0.82 3.32667 0.946667L4.66667 1.39333C5.04667 1.52 5.27333 1.94 5.18667 2.32667L4.92 3.52C4.83333 3.90667 4.47333 4.14667 4.09333 4.05333L3.77333 3.97333C3.77333 3.97333 4.28 6.64 6.22667 8.82667C8.17333 11.0133 10.5467 11.58 10.5467 11.58L10.4733 11.22C10.3867 10.8333 10.6 10.4333 10.9467 10.2267L12.14 9.51333C12.4867 9.30667 12.9267 9.44 13.16 9.77333L13.8267 10.7067C14.06 11.04 14.0733 11.4933 13.86 11.8267L13.8467 11.84C13.6 12.2267 13.2 12.5067 12.72 13.04Z",
  stroke: "currentColor",
  "stroke-width": "1.33",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_5 = {
  key: 3,
  d: "M6 12L10 8L6 4",
  stroke: "currentColor",
  "stroke-width": "1.33",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_6 = {
  key: 4,
  d: "M10 12L6 8L10 4",
  stroke: "currentColor",
  "stroke-width": "1.33",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_7 = {
  key: 5,
  d: "M12.5 12.5L17.5 17.5M8.33333 14.1667C5.11167 14.1667 2.5 11.555 2.5 8.33333C2.5 5.11167 5.11167 2.5 8.33333 2.5C11.555 2.5 14.1667 5.11167 14.1667 8.33333C14.1667 11.555 11.555 14.1667 8.33333 14.1667Z",
  stroke: "currentColor",
  "stroke-width": "1.25",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_8 = {
  key: 6,
  d: "M12 4L4 12M4 4L12 12",
  stroke: "currentColor",
  "stroke-width": "1.33",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_9 = { key: 7 }
const _hoisted_10 = {
  key: 8,
  d: "M6 9L10 11M10 5L6 7M12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14ZM4 10C2.89543 10 2 9.10457 2 8C2 6.89543 2.89543 6 4 6C5.10457 6 6 6.89543 6 8C6 9.10457 5.10457 10 4 10ZM12 6C10.8954 6 10 5.10457 10 4C10 2.89543 10.8954 2 12 2C13.1046 2 14 2.89543 14 4C14 5.10457 13.1046 6 12 6Z",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_11 = {
  key: 9,
  d: "M10 4V14M10 4L14 2V12L10 14M10 4L6 2M10 14L6 12M6 12L2 14V4L6 2M6 12V2",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_12 = {
  key: 10,
  d: "M5.33366 2.66666H4.80046C4.05372 2.66666 3.68007 2.66666 3.39486 2.81199C3.14397 2.93982 2.94015 3.14364 2.81232 3.39453C2.66699 3.67974 2.66699 4.05339 2.66699 4.80013V5.33333M5.33366 2.66666H10.667M5.33366 2.66666V1.33333M10.667 2.66666H11.2005C11.9472 2.66666 12.32 2.66666 12.6053 2.81199C12.8561 2.93982 13.0606 3.14364 13.1885 3.39453C13.3337 3.67946 13.3337 4.05266 13.3337 4.79793V5.33333M10.667 2.66666V1.33333M2.66699 5.33333V11.2001C2.66699 11.9469 2.66699 12.32 2.81232 12.6053C2.94015 12.8561 3.14397 13.0603 3.39486 13.1881C3.67979 13.3333 4.05299 13.3333 4.79827 13.3333H11.2024C11.9477 13.3333 12.3203 13.3333 12.6053 13.1881C12.8561 13.0603 13.0606 12.8561 13.1885 12.6053C13.3337 12.3203 13.3337 11.9477 13.3337 11.2024V5.33333M2.66699 5.33333H13.3337M10.667 10.6667H10.6683L10.6683 10.668L10.667 10.668V10.6667ZM8.00033 10.6667H8.00166L8.00163 10.668L8.00033 10.668V10.6667ZM5.33366 10.6667H5.33499L5.33496 10.668L5.33366 10.668V10.6667ZM10.6683 8V8.00133L10.667 8.0013V8H10.6683ZM8.00033 8H8.00166L8.00163 8.00133L8.00033 8.0013V8ZM5.33366 8H5.33499L5.33496 8.00133L5.33366 8.0013V8Z",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_13 = {
  key: 11,
  d: "M6.33497 2.83815C6.13249 2.33193 5.64221 2 5.09701 2H3.26316C2.56554 2 2 2.5654 2 3.26302C2 9.19281 6.80719 14 12.737 14C13.4346 14 14 13.4344 14 12.7368L14.0003 10.9026C14.0003 10.3574 13.6685 9.86724 13.1622 9.66475L11.4046 8.96196C10.9499 8.78007 10.4322 8.86193 10.056 9.17546L9.60235 9.55378C9.07258 9.99526 8.29309 9.96015 7.80546 9.47252L6.52815 8.19404C6.04052 7.70641 6.00449 6.92756 6.44596 6.39779L6.82422 5.9442C7.13774 5.56797 7.22033 5.05011 7.03844 4.59539L6.33497 2.83815Z",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_14 = {
  key: 12,
  d: "M8.00033 2.66675C5.79119 2.66675 4.00033 4.45761 4.00033 6.66675V8.59605C4.00033 9.00423 3.87807 9.40309 3.64938 9.74113L2.85636 10.9131C2.49583 11.4458 2.87745 12.1667 3.52065 12.1667H12.48C13.1232 12.1667 13.5048 11.4458 13.1443 10.9131L12.3513 9.74113C12.1226 9.40309 12.0003 9.00423 12.0003 8.59605V6.66675C12.0003 4.45761 10.2095 2.66675 8.00033 2.66675ZM6.33366 13.3334C6.57766 14.1101 7.22765 14.6667 8.00033 14.6667C8.77301 14.6667 9.423 14.1101 9.66699 13.3334",
  stroke: "currentColor",
  "stroke-width": "1.33",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_15 = {
  key: 13,
  d: "M12.6667 8H3.33333M3.33333 8L8 3.33333M3.33333 8L8 12.6667",
  stroke: "currentColor",
  "stroke-width": "1.33",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_16 = {
  key: 14,
  d: "M6.87211 9.12822L10.1029 5.89745M13.4078 3.92578L10.6807 12.7888C10.4363 13.5831 10.314 13.9805 10.1032 14.1122C9.92043 14.2264 9.69403 14.2455 9.49487 14.1629C9.26528 14.0676 9.07887 13.6955 8.70712 12.952L6.97985 9.49735C6.92085 9.37936 6.89133 9.32066 6.85192 9.26953C6.81695 9.22415 6.77659 9.18328 6.73123 9.14833C6.68126 9.10986 6.62351 9.08097 6.51078 9.02457L3.04819 7.29329C2.30466 6.92152 1.93285 6.73546 1.83758 6.50585C1.75495 6.30672 1.7738 6.08014 1.88804 5.8973C2.01976 5.68649 2.41708 5.56401 3.21162 5.31953L12.0746 2.59244C12.6993 2.40024 13.0117 2.30422 13.2227 2.38168C13.4065 2.44914 13.5514 2.59389 13.6188 2.77766C13.6963 2.98854 13.6001 3.30083 13.4082 3.92485L13.4078 3.92578Z",
  stroke: "currentColor",
  "stroke-width": "1.33",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_17 = {
  key: 15,
  d: "M12.6665 13.3334H13.3332M10.6665 13.3334H9.33317V11.3334M11.3332 11.3334H13.3332V9.33341H12.6665M9.33317 9.33341H10.6665M2.6665 11.3332C2.6665 10.712 2.6665 10.4014 2.768 10.1563C2.90332 9.82963 3.16272 9.57023 3.48942 9.43491C3.73445 9.33341 4.04508 9.33341 4.66633 9.33341C5.28759 9.33341 5.59856 9.33341 5.84359 9.43491C6.17029 9.57023 6.42962 9.82963 6.56494 10.1563C6.66644 10.4014 6.66644 10.7122 6.66644 11.3334C6.66644 11.9547 6.66644 12.2653 6.56494 12.5103C6.42962 12.837 6.17029 13.0965 5.84359 13.2319C5.59856 13.3333 5.28759 13.3333 4.66633 13.3333C4.04508 13.3333 3.73445 13.3333 3.48942 13.2319C3.16272 13.0965 2.90332 12.8372 2.768 12.5105C2.6665 12.2655 2.6665 11.9545 2.6665 11.3332ZM9.33317 4.66658C9.33317 4.04532 9.33317 3.73469 9.43466 3.48966C9.56999 3.16296 9.82938 2.90357 10.1561 2.76824C10.4011 2.66675 10.7117 2.66675 11.333 2.66675C11.9543 2.66675 12.2652 2.66675 12.5103 2.76824C12.837 2.90357 13.0963 3.16296 13.2316 3.48966C13.3331 3.73469 13.3331 4.04549 13.3331 4.66675C13.3331 5.288 13.3331 5.59863 13.2316 5.84366C13.0963 6.17036 12.837 6.42986 12.5103 6.56519C12.2652 6.66668 11.9543 6.66668 11.333 6.66668C10.7117 6.66668 10.4011 6.66668 10.1561 6.56519C9.82938 6.42986 9.56999 6.17054 9.43466 5.84383C9.33317 5.5988 9.33317 5.28783 9.33317 4.66658ZM2.6665 4.66658C2.6665 4.04532 2.6665 3.73469 2.768 3.48966C2.90332 3.16296 3.16272 2.90357 3.48942 2.76824C3.73445 2.66675 4.04508 2.66675 4.66633 2.66675C5.28759 2.66675 5.59856 2.66675 5.84359 2.76824C6.17029 2.90357 6.42962 3.16296 6.56494 3.48966C6.66644 3.73469 6.66644 4.04549 6.66644 4.66675C6.66644 5.288 6.66644 5.59863 6.56494 5.84366C6.42962 6.17036 6.17029 6.42986 5.84359 6.56519C5.59856 6.66668 5.28759 6.66668 4.66633 6.66668C4.04508 6.66668 3.73445 6.66668 3.48942 6.56519C3.16272 6.42986 2.90332 6.17054 2.768 5.84383C2.6665 5.5988 2.6665 5.28783 2.6665 4.66658Z",
  stroke: "#0E0E22",
  "stroke-width": "1.33",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}

import type { PropType } from 'vue'

type IconName =
  | 'arrow-right'
  | 'arrow-left'
  | 'chevron-left'
  | 'chevron-right'
  | 'search'
  | 'close'
  | 'cart'
  | 'share'
  | 'map'
  | 'calendar'
  | 'phone'
  | 'bell'
  | 'telegram'
  | 'whatsapp'
  | 'viber'
  | 'qr-code'

type IconClassName =
  | string
  | Record<string, boolean>
  | Array<string | Record<string, boolean>>


export default /*@__PURE__*/_defineComponent({
  __name: 'QbIcon',
  props: {
  name: {
    type: String as PropType<IconName>,
    required: true
  },
  size: {
    type: [Number, String],
    default: 24
  },
  color: {
    type: String,
    default: undefined
  },
  className: {
    type: [String, Array, Object] as PropType<IconClassName>,
    default: ''
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.size,
    height: __props.size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: _normalizeClass(__props.className),
    style: _normalizeStyle({
      color: __props.color,
      width: typeof __props.size === 'number' ? __props.size + 'px' : __props.size,
      height: typeof __props.size === 'number' ? __props.size + 'px' : __props.size
    })
  }, [
    (__props.name === 'arrow-right')
      ? (_openBlock(), _createElementBlock("path", _hoisted_2))
      : (__props.name === 'whatsapp')
        ? (_openBlock(), _createElementBlock("path", _hoisted_3))
        : (__props.name === 'viber')
          ? (_openBlock(), _createElementBlock("path", _hoisted_4))
          : (__props.name === 'chevron-right')
            ? (_openBlock(), _createElementBlock("path", _hoisted_5))
            : (__props.name === 'chevron-left')
              ? (_openBlock(), _createElementBlock("path", _hoisted_6))
              : (__props.name === 'search')
                ? (_openBlock(), _createElementBlock("path", _hoisted_7))
                : (__props.name === 'close')
                  ? (_openBlock(), _createElementBlock("path", _hoisted_8))
                  : (__props.name === 'cart')
                    ? (_openBlock(), _createElementBlock("g", _hoisted_9, [...(_cache[0] || (_cache[0] = [
                        _createElementVNode("path", {
                          d: "M4 1.33333L2 4V13.3333C2 14.0697 2.59695 14.6667 3.33333 14.6667H12.6667C13.403 14.6667 14 14.0697 14 13.3333V4L12 1.33333H4Z",
                          stroke: "currentColor",
                          "stroke-width": "1.33",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, null, -1),
                        _createElementVNode("line", {
                          x1: "2",
                          y1: "4",
                          x2: "14",
                          y2: "4",
                          stroke: "currentColor",
                          "stroke-width": "1.33",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, null, -1),
                        _createElementVNode("path", {
                          d: "M10.6667 6.66667C10.6667 8.13943 9.47276 9.33333 8 9.33333C6.52724 9.33333 5.33333 8.13943 5.33333 6.66667",
                          stroke: "currentColor",
                          "stroke-width": "1.33",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, null, -1)
                      ]))]))
                    : (__props.name === 'share')
                      ? (_openBlock(), _createElementBlock("path", _hoisted_10))
                      : (__props.name === 'map')
                        ? (_openBlock(), _createElementBlock("path", _hoisted_11))
                        : (__props.name === 'calendar')
                          ? (_openBlock(), _createElementBlock("path", _hoisted_12))
                          : (__props.name === 'phone')
                            ? (_openBlock(), _createElementBlock("path", _hoisted_13))
                            : (__props.name === 'bell')
                              ? (_openBlock(), _createElementBlock("path", _hoisted_14))
                              : (__props.name === 'arrow-left')
                                ? (_openBlock(), _createElementBlock("path", _hoisted_15))
                                : (__props.name === 'telegram')
                                  ? (_openBlock(), _createElementBlock("path", _hoisted_16))
                                  : (__props.name === 'qr-code')
                                    ? (_openBlock(), _createElementBlock("path", _hoisted_17))
                                    : _createCommentVNode("", true)
  ], 14, _hoisted_1))
}
}

})